import script from "./RegisterApp.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterApp.vue?vue&type=script&setup=true&lang=js"

import "./RegisterApp.vue?vue&type=style&index=0&id=45f7ebc8&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f7ebc8"]])

export default __exports__